(function($,window) {

    'use strict';

    // Load once the DOM is ready
    $(document).ready(function() {

        // Not on the woocommerce payment methods template or checkout payment view, bail here
        if( ! $('body.woocommerce-payment-methods').length && ! $('body.woocommerce-checkout #payment').length ) {
            return;
        }

        // Load ModeEffectPro ajax helper or bail if not present
        let ajax = window.ModeEffectPro || null;

        if( ! ajax ) {
            return;
        }

        // Load the payment methods table and dialogs
        let methodsTable$ = $('body.woocommerce-payment-methods').length ?
            $('.woocommerce-MyAccount-paymentMethods') : $('#payment');

        let editDialog$ = $('#me_braintree_edit_expiry');

        // Setup the handler
        let handler = (function(table$,dialog$,ajax) {
            return {

                /**
                *   Initializes the handler
                *
                *   @return void
                */
                init: function() {

                    // Prepare any events
                    this.prepareEvents();

                    // Return the handler
                    return this;

                },

                /**
                *   Overrides select default payment method action events and overrides to handler
                *
                *   @return void
                */
                prepareEvents: function() {

                    // Payment Methods View Actions
                    table$.find('.woocommerce-PaymentMethod--details .me_braintree_edit_button').off('click').on('click',function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        handler.handleEditExpiration(this);
                    });

                    table$.find('.woocommerce-PaymentMethod--actions .button.edit').off('click').on('click',function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        $(this).closest('.payment-method').find('.me_braintree_edit_button').click();
                    });

                    // Checkout View Actions
                    $(document).on('click','.me_braintree_edit_button',function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        handler.handleCheckoutEditExpiration(this);
                    });

                    // Modal Actions
                    $('form.me_braintree_edit_expiry_form').on('submit',function(e) {
                        e.preventDefault();
                        handler.handleUpdateExpiration();
                        return false;
                    });

                },

                /**
                *   Opens the update expiration modal for a payment method
                *
                *   @return void
                */
                handleEditExpiration: function(button) {

                    let method$ = $(button).closest('.payment-method');
                    let nickname$ = method$.find('input[name=nickname]');

                    dialog$.data('method',method$);

                    dialog$.find('input[name=nickname]')
                        .val(nickname$.val() || method$.find('.payment-method-method .view').text())
                        .off('change')
                        .on('change',function() {
                           nickname$.val($(this).val());
                        });

                    this.openDialog(button);

                },

                /**
                *   Opens the update expiration modal for a payment method
                *
                *   @return void
                */
                handleCheckoutEditExpiration: function(button) {

                    let method$ = $(button).closest('.sv-wc-payment-gateway-payment-form-saved-payment-method');
                    let nickname$ = method$.find('.nickname');

                    if( ! nickname$.length ) {
                        method$.find('span.title').prepend( nickname$ = $(document.createElement('span')).addClass('nickname') );
                    }

                    dialog$.data('method',method$);

                    dialog$.find('input[name=nickname]')
                        .val(nickname$.text())
                        .off('change')
                        .on('change',function() {
                           nickname$.text($(this).val());
                        });

                    // Hide the nickname field for now as checkout modal doesnt update it
                    dialog$.find('input[name=nickname]').closest('.form-group').toggle(false);

                    this.openDialog(button);

                },

                /**
                *   Opens the modal dialog
                *
                *   @param object button
                *
                *   @return void
                */
                openDialog: function(button) {

                    // Prepare fields
                    let expires = $(button).data('expires').split('/');

                    dialog$.find('select[name=month]').val(Number(expires[0]));
                    dialog$.find('select[name=year]').val(Number(expires[1]));

                    dialog$.find('input[name=cvv]').val('');

                    dialog$.data('gateway',$(button).data('gateway'));
                    dialog$.data('token',$(button).data('token'));

                    // Open the modal
                    $(button).jqmodal({
                        blockerClass: 'braintree-edit',
                    });

                    // Clear and reset any message
                    dialog$.find('.response')
                        .hide()
                        .find('.message')
                        .html('')
                        .removeClass('is_error');

                    // Show the loader
                    dialog$.find('.loader').show();
                    dialog$.find('.screen').show();

                    // Load the billing addres
                    this.loadBillingAddress(
                        dialog$.data('gateway'),
                        dialog$.data('token'),
                        function(response) {

                            // Hide the loader
                            dialog$.find('.loader').hide();
                            dialog$.find('.screen').hide();

                            // No or unsuccessful response, bail here
                            if( ! response || ! response.success ) {
                                dialog$.find('.response').find('.message').addClass('is_error');
                                return;
                            }

                            // Show the form
                            dialog$.find('.form-details').show();

                        }
                    );

                },

                /**
                *   Handles loading the billing address for the gateway and token upon modal load
                *
                *   @param string gateway
                *   @param string token
                *   @param callable $cb
                *
                *   @return void
                */
                loadBillingAddress: function(gateway,token,cb) {

                    // Prepare the data
                    let data = {
                        gateway: gateway,
                        'card-token': token,
                    };

                    // Fetch the billing address
                    ajax.post('me_braintree_edit_billing_address',data,function(response) {

                        // No or unsuccessful response, bail here
                        if( ! response || ! response.success ) {
                            return;
                        }

                        // Update the billing fields
                        dialog$.find('input[name=billing_first_name]').val(response.data.billing_address.firstName || '');
                        dialog$.find('input[name=billing_last_name]').val(response.data.billing_address.lastName || '');
                        dialog$.find('input[name=billing_address_1]').val(response.data.billing_address.streetAddress || '');
                        dialog$.find('input[name=billing_address_2]').val(response.data.billing_address.extendedAddress || '');
                        dialog$.find('input[name=billing_city]').val(response.data.billing_address.locality || '');
                        dialog$.find('input[name=billing_state]').val(response.data.billing_address.region || '');
                        dialog$.find('input[name=billing_postcode]').val(response.data.billing_address.postalCode || '');

                        // Run any callback
                        if(cb) {
                            cb(response);
                        }

                    });

                },

                /**
                *   Handles updating the card expiration via dialog modal
                *
                *   @return void
                */
                handleUpdateExpiration: function() {

                    // Show the loader
                    dialog$.find('.loader').show();
                    dialog$.find('.screen').show();

                    // Clear and reset response
                    dialog$.find('.response')
                        .hide()
                        .find('.message')
                        .html('')
                        .removeClass('is_error');

                    // Setup the post data
                    let data = {
                        'gateway': dialog$.data('gateway'),
                        'card-token' : dialog$.data('token'),
                        'month': dialog$.find('select[name=month]').val(),
                        'year': dialog$.find('select[name=year]').val(),
                        'cvv': dialog$.find('input[name=cvv]').val(),
                        'billing_address': {
                            'firstName': dialog$.find('input[name=billing_first_name]').val(),
                            'lastName': dialog$.find('input[name=billing_last_name]').val(),
                            'streetAddress': dialog$.find('input[name=billing_address_1]').val(),
                            'extendedAddress': dialog$.find('input[name=billing_address_2]').val(),
                            'locality': dialog$.find('input[name=billing_city]').val(),
                            'region': dialog$.find('input[name=billing_state]').val(),
                            'postalCode': dialog$.find('input[name=billing_postcode]').val(),
                        },
                    };

                    // Save the card
                    ajax.post('me_braintree_edit_expiry',data,function(response) {

                        // Hide the loader
                        dialog$.find('.loader').hide();
                        dialog$.find('.screen').hide();

                        // Show the response
                        dialog$.find('.response')
                            .show()
                            .find('.message')
                            .html(response.data.message);

                        // On failure, add error class to message, and bail here
                        if( ! response.success ) {
                            dialog$.find('.response').find('.message').addClass('is_error');
                            return;
                        }

                        // Update the payment method expires input
                        dialog$.data('method').find('.payment-method-expires input[name=expires]').val(
                            dialog$.find('select[name=month]').val().padStart(2,'0') + '/' + dialog$.find('select[name=year]').val().padStart(2,'0')
                        );

                        // Update the payment method shown
                        dialog$.data('method').find('.payment-method-expires > span').add(dialog$.data('method').find('.checkout-payment-method-expires')).text(
                            dialog$.find('select[name=month]').val().padStart(2,'0') + '/' + dialog$.find('select[name=year]').val().padStart(2,'0')
                        );

                        // Update expiration data on button
                        dialog$.data('method').find('.me_braintree_edit_button[data-expires]')
                            .data('expires',dialog$.find('select[name=month]').val().padStart(2,'0') + '/' + dialog$.find('select[name=year]').val().padStart(2,'0'));

                        // Save payment method for any changes to nickname if not in checkout view
                        if( ! dialog$.data('method').is('.woocommerce-checkout-payment') ) {
                            dialog$.data('method').find('.button.save').trigger('click');
                        }

                        // Hide the form
                        dialog$.find('.form-details').hide();

                        // Close the modal
                        dialog$.find('.close-jqmodal').trigger('click');

                    });

                },

            };
        })(methodsTable$,editDialog$,ajax).init();

    });

})(jQuery,window);
